import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import PapperBlock from "../PapperBlock/PapperBlock";
import useStyles from "../SocialMedia/jss/socialMedia-jss";

function Programms() {
  const theme = useTheme();
  const { classes, cx } = useStyles();

  return (
    <div>
      <Paper>
        {/* ----------------------------------------------------------------------*/}
        {/* People */}
        <PapperBlock
          title="Programs"
          icon="ion-ios-people-outline"
          whiteBg
          noMargin
          desc=""
        >
          <List component="nav" dense className={classes.profileList}>
            <ListItem button className={classes.listPeople}>
              <ListItemAvatar>
                <Avatar className={cx(classes.avatar, classes.orangeAvatar)}>
                  C
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                className={classes.textPrimary}
                primary="Center for Development of Advance Computing"
              />
              <Button color="secondary" size="small">
                Connect
              </Button>
            </ListItem>
            <ListItem button className={classes.listPeople}>
              <ListItemAvatar>
                <Avatar className={cx(classes.avatar, classes.purpleAvatar)}>
                  J
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                className={classes.textPrimary}
                primary="e-learning"
              />
              <Button color="secondary" size="small">
                Connect
              </Button>
            </ListItem>
            <ListItem button className={classes.listPeople}>
              <ListItemAvatar>
                <Avatar className={cx(classes.avatar, classes.pinkAvatar)}>
                  V
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                className={classes.textPrimary}
                primary="Cyber Quiz"
              />
              <Button color="secondary" size="small">
                Connect
              </Button>
            </ListItem>
            <ListItem button className={classes.listPeople}>
              <ListItemAvatar>
                <Avatar className={cx(classes.avatar, classes.greenAvatar)}>
                  H
                </Avatar>
              </ListItemAvatar>
              <ListItemText className={classes.textPrimary} primary="ARMS" />
              <Button color="secondary" size="small">
                Connect
              </Button>
            </ListItem>
            <ListItem button className={classes.listPeople}>
              <ListItemAvatar>
                <Avatar className={cx(classes.avatar, classes.greenAvatar)}>
                  H
                </Avatar>
              </ListItemAvatar>
              <ListItemText className={classes.textPrimary} primary="V-labs" />
              <Button color="secondary" size="small">
                Connect
              </Button>
            </ListItem>
          </List>
          <Divider className={classes.divider} />
          <Grid container justifyContent="center">
            <Button color="secondary" className={classes.button}>
              See All
            </Button>
          </Grid>
        </PapperBlock>
      </Paper>
      <Divider className={classes.divider} />
    </div>
  );
}

export default Programms;
